/**
 * 一般内部使用，端能力注册
 * @file Created on Thu Nov 15 2018
 * @author wangyongqing <wangyongqing01@baidu.com>
 */

import boxjsFilter from 'boxjs/dist/core/BDPolyfill/filter';
import boxjsVersionMap from 'boxjs/dist/core/versionMap';
/**
 * 一般内部使用，boxjs 版本的端能力注册
 * @function register
 * @param {string} name - 端能力名称
 * @param {array} args - 端能力filter/versionMap
 */
export default (name, ...args) => {
    args.forEach(obj => {
        if (obj.v) {
            // 说明是新的
            Object.assign(boxjsVersionMap, {
                [`${name}`]: obj
            });
        } else {
            Object.assign(boxjsFilter, {
                [`${name}`]: obj
            });
        }
    });
};
